module.exports = __webpack_public_path__ + "img/A-1186378-1459856693-3656.jpeg.9446612c.jpg";